import { Directive, inject } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';

import { AbstractComponent } from './abstract.component';

@Directive()
export abstract class AbstractParentComponent extends AbstractComponent {
    private readonly oneIRedirectKey: string = 'no_redirect';

    /**
     * One i query param, override isOne()
     */
    protected oneQueryParam: boolean;

    protected readonly route = inject(ActivatedRoute);

    public constructor() {
        super();
        this.route.queryParams.subscribe((params: Params) => {
            this.oneQueryParam = params[this.oneIRedirectKey] === 'true';
        });
    }
}
